import axios from 'axios'

// 1. 创建 axios 实例
const service = axios.create({
  baseURL: 'https://localhost:5000/api', // 你的后端地址
  timeout: 10000 // 请求超时时间
})

// ======================================
// 【前置拦截器：发请求之前统一处理】
// ======================================
service.interceptors.request.use(
  config => {
    // 这里可以加 token、请求头、加载动画等
    console.log('🔴 请求发送前：', config.url)
    
    // 例：加请求头 token
    // config.headers['token'] = '你的token'

    return config
  },
  error => {
    console.error('请求错误：', error)
    return Promise.reject(error)
  }
)

// ======================================
// 【后置拦截器：请求返回后统一处理】
// ======================================
service.interceptors.response.use(
  response => {
    console.log('🟢 请求成功返回：', response.config.url)
    return response.data // 直接返回 data，页面不用再 .data
  },
  error => {
    console.error('请求失败：', error.message)
    
    // 统一错误提示
    if (error.message.includes('Network Error')) {
      alert('后端服务未启动，请检查后端！')
    }
    if (error.message.includes('timeout')) {
      alert('请求超时！')
    }

    return Promise.reject(error)
  }
)

export default service